import React from "react";
import { useParams } from 'react-router-dom';
import { useEffect, useState } from "react";
import Row from "./Row";
import request from './requests';
import './Details.css';

export default function Details() {
    const { id } = useParams()
    const [movie, setMovie] = useState([]);
    const API_KEY = "2960a53aab03511d610e160a3a9f5bc4";
    const BASE = "https://api.themoviedb.org/3";
    const IMG = "https://image.tmdb.org/t/p/original";
    const IMDB = "https://www.imdb.com/title/";
    const url = BASE + `/movie/${id}?api_key=${API_KEY}`;
    // const url = BASE + `/trending/all/week?api_key=${API_KEY}&language=en-US`;

    const fetchMovies = fetch(url);
    const details = '/details/';

    useEffect(() => {
        Promise.all([fetchMovies])
            .then(async (response) => {
                const moviesData = await response[0].json();
                setMovie(moviesData);
            })
            .catch((err) => console.log(err));
    }, [details]);

    console.log(movie);

    return (
        <div className="details">
            <header>
                <div
                    className="banner"
                    style={{
                        backgroundImage: `linear-gradient(90deg , black , transparent), url(${IMG}${movie.backdrop_path})`,
                        //   backgroundImage: `url(${IMG}${movie.backdrop_path}), linear-gradient(90deg , black , transparent), url(${IMG}${movie.backdrop_path})`,
                        //   backgroundImage: `transparent`,
                        backgroundPosition: "center center",
                    }}
                >
                    {/* <div className="banner-content"> */}
                    <h1 className="banner-title">
                        {movie.name || movie.title || movie.original_title}
                    </h1>
                    <div className="runtime">
                        <p>{movie.release_date}</p> <p>|</p>    <p> {movie.runtime}min</p>
                    </div>
                    <div className="banner-desc">{movie.overview}</div>
                    <div className="runtime">
                        {movie.genres && movie.genres.map((genre) => (
                            <p>{genre.name}</p>
                        ))}
                    </div>
                    <a href={`${IMDB}${movie.imdb_id}`} >
                        <button className="imdb">IMDB</button>
                    </a>
                </div>
                {/* {movie.genres && movie.genre.map((genre) => { */}
                <>
                    <Row title="Recommended Movies" fetchUrl={request.fetchThrillerMovies} />
                    <Row title="Comedy Movies" fetchUrl={request.fetchComedyMovies} />
                </>
                {/* })} */}
            </header>
        </div>
    )
}
